module.exports = __webpack_public_path__ + "img/armor-vest.80197270.svg";